<template>
    <div class="preguide-container">
            <TitlePart text="Contact Us"/>
            <div class="left-aligned-text" style="line-height:150%">
                        <p>Address: 181 Chatham Road South, Hung Hom, Hong Kong, China <br>(The Hong Kong Polytechnic University)</p>
                        <p>Email: <a class="mail" href="mailto:">asiacarto@polyu.edu.hk</a> or <a class="mail" href="mailto:">info@asiacarto.org</a></p>
            </div>
            <br>
            <br>
            <br>
        </div>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>